import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, GridApi, GridOptions } from 'ag-grid-community';
import { CopyToExcelButtonComponent } from '../../../../core/components/buttons/copy-to-excel/copy-to-excel-button.component';
import { LinkButtonComponent } from '../../../../core/components/buttons/link/link-button.component';
import { AG_GRID_DEFAULT_OPTIONS } from '../../../../core/config/aggrid.default.config';
import { FacturaGastoDtoOut } from '../../../models/gasto.model';
import { FacturaSepaNoProcesableDtoOut } from '../../../models/sepa.model';
import { ContabilidadSepaService } from '../../../services/contabilidad-sepa.service';

@Component({
  selector: 'app-sepa-facturas-no-procesables',
  standalone: true,
  imports: [AgGridAngular, CommonModule, CopyToExcelButtonComponent],
  templateUrl: './sepa-facturas-no-procesables.component.html',
  styleUrl: './sepa-facturas-no-procesables.component.scss',
})
export class SepaFacturasNoProcesablesComponent implements OnInit {
  facturas: FacturaSepaNoProcesableDtoOut[] = [];

  isColumnDropdownOpen = false;
  gridApi!: GridApi;

  constructor(
    private readonly router: Router,
    private readonly sepaService: ContabilidadSepaService
  ) {}

  ngOnInit(): void {
    this.refreshGridColumns();
    this.obtenerFacturas();
  }

  obtenerFacturas(): void {
    this.sepaService.getFacturasNoProcesables().subscribe((facturas) => {
      this.facturas = facturas;
    });
  }

  gridOptions: GridOptions = {
    ...AG_GRID_DEFAULT_OPTIONS,
    onGridReady: (params) => (this.gridApi = params.api),
    onRowDoubleClicked: this.onRowDoubleClicked.bind(this),
  };

  columnDefs: ColDef[] = [];

  columnOptions = [
    { field: 'id', headerName: 'ID', selected: true },
    { field: 'codFactura', headerName: 'Numero de Factura', selected: true },
    { field: 'codContable', headerName: 'Código Contable', selected: true },
    { field: 'fechaMandato', headerName: 'Fecha Mandato', selected: true, filter: 'agDateColumnFilter' },
    { field: 'cuentaBancaria', headerName: 'Cuenta Bancaria', selected: true },
    { field: 'baseImponible', headerName: 'Base Imponible', selected: true },
    { field: 'importeTotal', headerName: 'Importe Total', selected: true },
    { field: 'actions', label: 'Opciones', selected: true },
  ];

  toogleColumnDropdown(): void {
    this.isColumnDropdownOpen = !this.isColumnDropdownOpen;
  }

  toggleColumnaSeleccionada(option: any): void {
    option.selected = !option.selected;
    this.refreshGridColumns();
  }

  refreshGridColumns(): void {
    this.columnDefs = this.columnOptions.map((col) => {
      if (col.field === 'actions') {
        return {
          field: col.field,
          headerName: col.headerName,
          hide: this.isColumnahide(col.field),
          cellRenderer: LinkButtonComponent,
          cellRendererParams: (params: any) => ({
            link: `/facturas-suministros/${params.data.id}`,
          }),
          resizable: false,
          sortable: false,
          filter: false,
          suppressMovable: true,
        };
      }

      return {
        field: col.field,
        headerName: col.headerName,
        filter: col.filter,
        hide: this.isColumnahide(col.field),
      };
    });
  }

  isColumnahide(columna: string): boolean {
    const column = this.columnOptions.find((col) => col.field === columna);
    return !column?.selected;
  }

  onRowDoubleClicked({ data }: { data: FacturaGastoDtoOut }): void {
    const facturaId = data.id;
    this.router.navigate([`/facturas-suministros/${facturaId}`]);
  }
}
